import { Routes } from '@angular/router';

export const signupRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./signup.page').then((m) => m.SignupPage),
  },
];
